export { CustomerFormFields } from './CustomerFormFields'
export { useCustomerFormFields } from './useCustomerFormFields'
export type {
  CustomerFormFieldsData,
  CustomerFormFieldControls,
  CustomerFormSectionValidation,
  CustomerCustomPropertiesConfig,
  UseCustomerFormFieldsProps,
  CustomerFormErrors,
  Contact,
  CustomerCustomProperty,
  TaxRegistrationEntry,
  TaxStatus
} from './types'
export { getCustomerContactsValidators } from './components/CustomerContactsField'
export { CustomerAliasField } from './components/CustomerAliasField'
